<template>
    <div>
        <router-view name="header"></router-view>

        <main>
            <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>

        <router-view name="footer"></router-view>

        <gh-back-to-top></gh-back-to-top>
    </div>
</template>

<script>
    import ghBackToTop from '../components/ui/backToTop.vue';
    import jwt from '../utils/jwt';

    export default {
        components: {ghBackToTop},

        mounted() {
            this.$router.onReady(() => {
                if (this.$route.query.accessToken) {
                    jwt.setToken(this.$route.query.accessToken)
                    window.location.replace('/dashboard')
                }
            });
        }
    }
</script>